module.exports = __webpack_public_path__ + "static/media/iti_logo.31552a30.svg";